<template>
  <div>
    <vxe-grid
      ref="itemTable"
      auto-resize
      highlight-hover-row
      size="mini"
      :data="tableData"
      :columns="tableColumns"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      :height="tableHeight - 100"
      border
      :edit-rules="validRules"
      @edit-closed="changeDate"
      :footer-method="() => footerData"
      show-footer
    >
      <template v-slot:top>
        <div class="d-flex mt-2 mb-2">
          <div class="title">
            {{ $l('form_label_plan_detail') || '计划明细' }}
          </div>
          <div>
            <el-divider direction="vertical" v-if="!disabled"></el-divider>
          </div>
          <el-button
            size="mini"
            @click="addNewsRow()"
            v-if="!disabled"
            style="border-radius: 4px !important;"
            >{{ $l('form_label_add_detail') || '添加明细' }}
          </el-button>
          <el-button
            size="mini"
            v-if="!disabled"
            @click="openDialogVisible()"
            style="border-radius: 4px !important;"
            >{{ $l('form_label_batch_add') || '批量添加' }}
          </el-button>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <i class="el-icon-delete tool-btn" @click="delRow(row)"></i>
        </div>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
    <el-dialog
      :title="$l('form_label_batch_add_plan_detail') || '批量添加计划明细'"
      :visible.sync="chooseDialogVisible"
      v-if="chooseDialogVisible"
      v-el-dialog-drag
      append-to-body
      width="500px"
      :before-close="() => closeDialog()"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      destroy-on-close
    >
      <el-form
        class="mt-2"
        ref="form"
        :model="formData"
        :rules="rules"
        size="mini"
      >
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_deliveryDate') || '到货日期'"
              prop="deliveryDate"
            >
              <el-date-picker
                v-model="formData.deliveryDate"
                type="date"
                value-format="yyyy-MM-dd"
                :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_planContainerQty') || '货柜数量'"
              prop="planContainerQty"
            >
              <el-input-number
                v-model="formData.planContainerQty"
                :controls="false"
                style="width: 100%"
                :precision="0"
                :min="1"
                :max="99"
                size="mini"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog()" size="small">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="confirm()" type="primary" size="small">{{
          $l('btn_confirm_Add') || '确认添加'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import { format, add } from '@/libs/util.number.js'
import validate from '@/libs/util.validate'
import dayjs from 'dayjs'
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    evgPlanOrderCode: { type: String, default: '' },
    transitTimes: { type: Number, default: 0 },
    shippingTimes: { type: Number, default: 0 },
  },
  data() {
    return {
      tableData: [],
      formData: {
        planContainerQty: 1,
      },
      format: (number) => format(number),
      chooseDialogVisible: false,
      rules: {
        deliveryDate: [
          {
            trigger: 'change',
            required: true,
            message: this.$l('INDEX.tips_pleaseSelectData') || '请选择数据',
          },
        ],
        planContainerQty: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    tableColumns() {
      return tableColumns(this)
    },
    validRules() {
      return {
        deliveryDate: [
          {
            required: true,
            trigger: 'change',
            message: this.$l('INDEX.tips_select_data') || '请选择...',
          },
        ],
      }
    },
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)
      const data = this.getTableData()
      const totalColumnValues = data.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns
        .filter((c) => c.visible != false)
        .map((t) => {
          const val = totalColumnValues[t.field]
          return val ? format(val) : ''
        })
      result[2] = this.$l('INDEX.total') || '合计'
      return [result]
    },
  },
  watch: {
    transitTimes: {
      handler(val) {
        if (val) {
          this.changeDate()
        }
      },
    },
    shippingTimes: {
      handler(val) {
        if (val) {
          this.changeDate()
        }
      },
    },
  },
  mounted() {},
  methods: {
    loadData(data) {
      this.tableData = data
    },
    async addNewsRow() {
      if (!this.checkDays()) return
      const $itemTable = this.$refs.itemTable
      const { row: newRow } = await $itemTable.insertAt({
        planContainerQty: 1,
      })
      await $itemTable.setActiveCell(newRow, 'deliveryDate')
    },
    async delRow(row) {
      this.$refs.itemTable.remove(row)
      this.sortTable()
    },
    getTableData() {
      const { fullData } = this.$refs.itemTable.getTableData()
      return fullData
    },
    sortTable() {
      this.$refs.itemTable.sort('deliveryDate', 'asc')
    },
    async validate() {
      const result = await this.$refs.itemTable.validate(true).catch(() => true)
      return !result
    },
    async changeDate() {
      const data = this.getTableData()
      if (data && data.length > 0) {
        data.forEach((e) => {
          e.endShippingDate = e.deliveryDate
            ? dayjs(e.deliveryDate)
                .subtract(this.transitTimes, 'day')
                .format('YYYY-MM-DD')
            : ''
          e.beginShippingDate = e.deliveryDate
            ? dayjs(e.endShippingDate)
                .subtract(this.shippingTimes, 'day')
                .format('YYYY-MM-DD')
            : ''
        })
      }
      this.sortTable()
    },
    closeDialog() {
      this.chooseDialogVisible = false
      this.formData = { planContainerQty: 1 }
    },
    openDialogVisible() {
      if (!this.checkDays()) return
      this.chooseDialogVisible = true
    },

    async confirm() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      if (this.loadingOpen()) return
      const { deliveryDate, planContainerQty } = this.formData
      const $itemTable = this.$refs.itemTable

      for (let i = 0; i < planContainerQty; i++) {
        await $itemTable.insertAt({
          deliveryDate: deliveryDate,
          planContainerQty: 1,
        })
      }
      this.loadingClose()
      this.closeDialog()
      this.$nextTick(() => {
        this.changeDate()
      })
    },
    checkDays() {
      if (!this.transitTimes) {
        this.$message.warning(
          this.$l('tips_transitTimes_must_be_greater_than_0') ||
            '运输周期须大于0'
        )
        return false
      }
      if (!this.shippingTimes) {
        this.$message.warning(
          this.$l('tips_shippingTimes_must_be_greater_than_0') ||
            '发运周期须大于0'
        )
        return false
      }
      return true
    },
  },
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 16px;
  color: #101010;
  font-weight: 600;
}
</style>
